import {db} from "../firebase";
import {UserInterface} from "../db/models/user";
import {getUid} from "./auth";
import {Collections} from "./collections";

export const updateUser = (partialUser: any) => {
    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    return db.collection(Collections.USERS).doc(uid).update(partialUser);
};

export const getUserByEmail = async (email: string) => {
    if (!email) return Promise.resolve(null);

    const userSnap = await db.collection(Collections.USERS).where("email", "==", email).get();
    const users = userSnap.docs.map(doc => doc.data());
    if (users.length > 0) return users[0];
    else return null;
}

export const updateUserDemo = async (userId: string, demo: boolean) => {
    if (!userId || demo == null) return Promise.reject("no params");

    let batch = db.batch();

    const userRef = db.collection(Collections.USERS).doc(userId);
    batch.update(userRef, {demo});

    const areasSnap = await db
        .collection(Collections.COMPANY_AREAS)
        .where("companyId", "==", userId)
        .get();
    const areaDocs = areasSnap.docs;
    const areasPromises = areaDocs.map((areaDoc) =>
        batch.update(areaDoc.ref, {demo})
    );
    await Promise.all(areasPromises);

    const rmsSnap = await db
        .collection(Collections.COMPANY_RMS)
        .where("companyId", "==", userId)
        .get();
    const rmsDocs = rmsSnap.docs;
    const rmsPromises = rmsDocs.map((rmDoc) => batch.update(rmDoc.ref, {demo}));
    await Promise.all(rmsPromises);

    return batch.commit();
};

export const getUserById = (uid: string): Promise<UserInterface | null> => {
    if (!uid) return Promise.reject("no uid");

    return db
        .collection(Collections.USERS)
        .doc(uid)
        .get()
        .then((doc) => (doc.exists ? (doc.data() as UserInterface) : null));
};

export const getUserListener = (observer: any) => {
    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    return db.collection(Collections.USERS).doc(uid).onSnapshot(observer);
};
